import Vue from 'vue'

export default {
    UPDATE_CONFIGURATIONS (state, value) {
      Vue.set(state, 'configurations', value);
    },
    SET_CONFIGURATIONS (state, value) {
      this.commit('UPDATE_CONFIGURATIONS', value);
    },
    SET_IMAGES (state, value) {
      this.commit('SET_CONFIGURATIONS', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/configurations/mutations.js